var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"profile__block__content profile__block__content--empty-state"},[_c('img',{attrs:{"src":"static/images/star_mod.svg","alt":""}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.props.text))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f47f5e","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/users/EmptyState.vue
// module id = null
// module chunks = 